import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatTRY } from "@/lib/pricing";
import { FolderOpen, Save, Trash2, Upload } from "lucide-react";

export function SavedDesigns({ designs, onSave, onLoad, onDelete }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const handleSave = () => {
    onSave(name.trim() || "İsimsiz Tasarım");
    setName("");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="saved-designs-btn" variant="outline" className="rounded-full">
          <FolderOpen className="w-4 h-4" /> Tasarımlarım ({designs.length})
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="saved-designs-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Kayıtlı Tasarımlar</DialogTitle>
        </DialogHeader>

        <div className="flex gap-2">
          <Input
            data-testid="save-design-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Bu tasarıma bir isim verin (örn. Yatak Odası Dolabı)"
          />
          <Button data-testid="save-design-btn" onClick={handleSave} className="rounded-full shrink-0">
            <Save className="w-4 h-4" /> Kaydet
          </Button>
        </div>

        <div className="mt-2 max-h-[320px] overflow-y-auto divide-y divide-[#E6DFD5]" data-testid="saved-designs-list">
          {designs.length === 0 ? (
            <p className="text-sm text-stone-500 py-6 text-center">
              Henüz kayıtlı tasarımınız yok. Üstteki alandan mevcut tasarımı kaydedin.
            </p>
          ) : (
            designs.map((d) => (
              <div key={d.id} className="flex items-center justify-between py-3" data-testid={`saved-design-${d.id}`}>
                <div className="min-w-0">
                  <p className="font-medium text-stone-900 truncate">{d.name}</p>
                  <p className="text-xs text-stone-500 font-mono">
                    {d.config.width}×{d.config.height}×{d.config.depth} cm • {d.config.shelves} raf •{" "}
                    {formatTRY(d.totalCost)}
                  </p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Button
                    data-testid={`load-design-${d.id}`}
                    size="sm"
                    variant="secondary"
                    className="rounded-full"
                    onClick={() => {
                      onLoad(d);
                      setOpen(false);
                    }}
                  >
                    <Upload className="w-3.5 h-3.5" /> Yükle
                  </Button>
                  <Button
                    data-testid={`delete-design-${d.id}`}
                    size="icon"
                    variant="ghost"
                    className="rounded-full text-red-500 hover:text-red-600 hover:bg-red-50"
                    onClick={() => onDelete(d.id)}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
